import React from 'react'
import PropTypes from 'prop-types'
import { SpinLoader } from 'src/components/loaders'
import { mergeProps } from 'src/util'
import { LocalSettingsContext } from 'src/contexts'
import SidebarHeader from './SidebarHeader'
import SidebarSeparator from './SidebarSeparator'
import SidebarToggler from './SidebarToggler'
import styles from './Sidebar.scss'

/**
 * A sidebar component, useful in combination with SidebarHeader and SidebarItem.
 */
const Sidebar = ({ loading, togglable, header, toggler, children, ...domProps }) => {
  const { isSidebarCollapsed } = LocalSettingsContext.use()
  return (
    <div {...mergeProps()({ className: [styles.sidebar, { [styles.collapsed]: isSidebarCollapsed }] }, domProps)}>
      {header && (
        <>
          {header}
          <SidebarSeparator className={styles.topSeparator} />
        </>
      )}
      {loading ? (
        <div className={styles.loader}>
          <SpinLoader color="white" />
        </div>
      ) : (
        <div className={styles.content}>{children}</div>
      )}
      {togglable && (
        <>
          <SidebarSeparator />
          {toggler}
        </>
      )}
    </div>
  )
}

Sidebar.defaultProps = {
  togglable: true,
  header: <SidebarHeader />,
  toggler: <SidebarToggler />,
}

Sidebar.propTypes = {
  /**
   * Whether the sidebar is loading or not.
   */
  loading: PropTypes.bool,
  /**
   * Whether the sidebar can be toggled or not.
   */
  togglable: PropTypes.bool,
  /**
   * The sidebar header component.
   */
  header: PropTypes.node,
  /**
   * The sidebar toggler component.
   */
  toggler: PropTypes.node,
  /**
   * The sidebar content.
   */
  children: PropTypes.node,
}

export default Sidebar
